export type MentionProfile = { username: string; name?: string | null; profileImageUrl?: string | null };

export function shouldFetchMentionProfile(mentionProfile: MentionProfile | null, normalizedUsername: string): boolean {
  if (!normalizedUsername) {
    return false;
  }
  if (!mentionProfile) {
    return true;
  }
  const hasProfileImage =
    typeof mentionProfile.profileImageUrl === 'string' && mentionProfile.profileImageUrl.length > 0;
  const hasName = typeof mentionProfile.name === 'string' && mentionProfile.name.length > 0;
  return !(hasProfileImage && hasName);
}
